import React from 'react'

export const Cylinder = ({ color, size = [1, 1, 1], position, rotation }) => {
	return (
		<mesh position={position} rotation={rotation} castShadow>
			{/* radius top, radius bottom, height, segments */}
			<cylinderGeometry args={size} />
			<meshStandardMaterial color={color} />
		</mesh>
	)
}
